// The file contents for the BCC PRODUCTION environment.

export const environment = {
  production: true,
  applicationId: 'BLACK_CAT_CARD',
  productId: 'BLACK_CAT_CARD',
  deviceId: 'BCC_DESKTOP',
  baseApi: 'https://api.blackcatcard.com/api',
  registrationUrl: 'https://registration.blackcatcard.com',
  authorizationType: 'fire-base',
  bankSettings: {
    bankLocationCode: 'MT',
    nationalBankCode: 'PAPY',
    defaultCurrency: 'EUR',
    transactionConfirmationType: 'SIGN'
  },
  countryFlagsUrl: '/assets/country-flags',
  cryptoService: {
    isActive: false,
    baseApi: 'https://ce-backend.star-bridge.lv',
    appUrl: 'https://desktop-crypto.bcc.scnetservices.ru'
  },
  supportChatSettings: {
    url: 'https://support-backend.blackcatcard.com/api/v1/',
    brokerURL: 'wss://support-rabbit.blackcatcard.com/ws',
    sessionConfig: {
      appId: 'BLACK_CAT_CARD',
      productId: 'BLACK_CAT_CARD',
    }
  },
  idScanConfig: {
    baseUrl: 'https://idscan-adapter-prod.star-bridge.lv'
  },
  idleTimeout: 900,
  analytics: {
    measurement_id: `G-6DPFJ8BNB5`
  },
  fcm: {
    apiKey: 'AIzaSyDe9BDL8Szmdxhcj9xurD0KvwDU6FXUtic',
    authDomain: 'blackcatcard-prod-80a52.firebaseapp.com',
    projectId: 'blackcatcard-prod-80a52',
    storageBucket: 'blackcatcard-prod-80a52.firebasestorage.app',
    messagingSenderId: '373541609418',
    appId: '1:373541609418:web:dc4209426e29202bf8f933',
    measurementId: 'G-VJPXC244F1'
  },
  paysafe: 'OT-339202:B-p1-0-67114aec-0-302d021500828477081e7a59cf1f674de9c8a39c49139b110302145366db50bf5bfc9b8a121d0d254b3436fb6afcb4',
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
